import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Separator } from '@/components/ui/separator'
import { SettingsSidebarNav } from '@/components/SettingsSideBar'
import { usePermissions } from '@/lib/states/session/hooks'
import { hasAnyPermission } from '@/lib/permissions/permissions'
import { useSupabaseSession } from '@/lib/supabase/supabaseProvider'

export const Route = createFileRoute('/_auth/_dashboard/settings/_layout')({
  component: SettingsPage,
})

const sidebarNavItems = [
  {
    title: 'Account',
    href: '/settings',
  },
  {
    title: 'Organisation',
    href: '/settings/organisation',
    requiredPermissions: ['organisation.manage'],
  },
  {
    title: 'Security',
    href: '/settings/security',
  },
  {
    title: 'Connected apps',
    href: '/settings/connected-apps',
  },
  {
    title: 'Subscription',
    href: '/settings/subscription',
    requiredPermissions: ['billing.manage'],
  },
]

function SettingsPage() {
  const permissions = usePermissions()
  const { subscription } = useSupabaseSession()
  const metadata =
    subscription?.metadata && typeof subscription.metadata === 'object'
      ? (subscription.metadata as Record<string, unknown>)
      : null
  const isInternalTrialSubscription = Boolean(
    !subscription?.price_id &&
      (metadata?.internal_trial === true ||
        metadata?.trial_source === 'internal'),
  )
  const visibleItems = sidebarNavItems.filter((item) => {
    if (item.href === '/settings/subscription' && isInternalTrialSubscription) {
      return false
    }
    if (!item.requiredPermissions?.length) return true
    return hasAnyPermission(item.requiredPermissions, permissions)
  })
  const navItems = visibleItems.map((item) => ({
    title: item.title,
    href: item.href,
  }))

  return (
    <>
      <div className="space-y-6 p-10 pb-16 md:block">
        <div className="space-y-0.5">
          <h2 className="text-2xl font-bold tracking-tight">Settings</h2>
          <p className="text-muted-foreground">
            Manage your account and organisation settings.
          </p>
        </div>
        <Separator className="my-6" />
        <div className="flex flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0">
          <aside className="-mx-4 lg:w-1/5">
            <SettingsSidebarNav items={navItems} />
          </aside>
          <div className="flex-1 lg:max-w-2xl">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  )
}
